import React from 'react';
// Components
import Banner from '../../../components/Banner/Banner';
import './IsiticiliPencere.css';

const IsiticiliPencere = () => {
  return (
    <div className="isiticili-pencere-page">
      {/* Main Content */}

      {/* Banner */}
      <Banner 
        title="Isıtıcılı Pencere" 
        backgroundImage={require('../../../assets/images/inner-banner.jpg')} 
      />

      {/* Page Content */}
      <section className="isiticili-pencere-content">
        <div className="container content-container">
          {/* First Section: Two Columns */}
          <div className="row">
            <div className="column">
              <img 
                src="https://teknoma.net/wp-content/uploads/2020/01/IMG_20191113_122702-768x1024.jpg" 
                alt="Isıtıcılı Pencere Left" 
              />
              <p>
                BK7 veya Borosilikat cam pencereler üzerine ITO kaplama ve üzerine iki adet elektrot kaplanmaktadır. Elektrotlar 3 katmanlı olup en üstte Au bulunmakta ve lehim yapılabilmektedir. Elektrotlarda yapılan 3 katman sayesinde yüzeye iyi tutunmakta ve sıcaklık değişimlerinde yüzeyden kalkma olmamaktadır. İstenirse yüzeyin sıcaklığını ölçmek için RTD de kaplanabilmektedir. Tüm kaplama adımları mıknatıssal saçtırma ile yapılmaktadır.
              </p>
            </div>
            <div className="column">
              <img 
                src="https://teknoma.net/wp-content/uploads/2019/11/isitmali_kamera_penceresi-831x1024.jpg" 
                alt="Isıtıcılı Pencere Right" 
              />
            </div>
          </div>

          {/* Second Section: Two Columns */}
          <div className="row">
            <div className="column">
              <img 
                src="https://teknoma.net/wp-content/uploads/2020/10/IMG_5492-sensorlu1-kare-1024x1007.jpg" 
                alt="Isıtıcılı Pencere Sensor" 
              />
            </div>
            <div className="column">
              <img 
                src="https://teknoma.net/wp-content/uploads/2020/11/IMG_1017-heater-FS-tempsens-983x1024.jpg" 
                alt="Isıtıcılı Pencere Heater" 
              />
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default IsiticiliPencere;
